import { Grid, Typography } from '@mui/material';
import { BakeasyChip } from './BakeasyChip';
import { t } from 'i18next';

interface MessageToList {
  data: [];
}

function BakeasyMessageToList(props: MessageToList) {
  return (
    <Grid sx={{ paddingLeft: 1 }}>
      {props?.data && (
        <Grid container spacing={0.25}>
          <Typography
            sx={{ alignSelf: 'center', fontWeight: 'bold', marginRight: 1 }}
          >
            {t('MESSAGE_TO')}
          </Typography>
          {props?.data?.map((item: any, index: any) => {
            return (
              <Grid item key={index}>
                <BakeasyChip label={item} />
              </Grid>
            );
            //return item + (index !== props?.data?.length - 1 ? ', ' : '');
          })}
        </Grid>
      )}
    </Grid>
  );
}

export default BakeasyMessageToList;
